var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-card-header",
            [
              _c("b", [_vm._v("Memberships")]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "headerBtn",
                  attrs: { variant: "outline-primary" },
                  on: {
                    click: function($event) {
                      _vm.showCreateUserMemberModal = true
                    }
                  }
                },
                [
                  _c("span", { staticClass: "button-text" }, [
                    _vm._v("Add Membership")
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.formatUserMemberships(_vm.usersMemberships).length > 0
            ? _c(
                "div",
                _vm._l(
                  _vm.formatUserMemberships(_vm.usersMemberships),
                  function(um) {
                    return _c(
                      "b-list-group",
                      { key: um.id, attrs: { flush: "" } },
                      [
                        _c("b-list-group-item", [
                          _c(
                            "a",
                            {
                              attrs: { href: "" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.toggleUpdateUserMemberModal(um.id)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._.get(
                                      um,
                                      "morganization.title",
                                      "Unknown"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isPrimaryOrg(um.morganization.id)
                            ? _c("img", {
                                attrs: {
                                  src: "static/img/Primary.png",
                                  height: "21",
                                  width: "21"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src:
                                "static/img/" +
                                (um.isOrgAdmin
                                  ? "AdminYes.png"
                                  : "AdminNo.png"),
                              height: "21",
                              width: "21"
                            }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src:
                                "static/img/" +
                                (um.isManager
                                  ? "ManagerYes.png"
                                  : "ManagerNo.png"),
                              height: "21",
                              width: "21"
                            }
                          }),
                          _vm._v(" "),
                          um.isDWUser
                            ? _c("img", {
                                attrs: {
                                  src: "static/img/" + "DWUserYes.png",
                                  height: "21",
                                  width: "21"
                                }
                              })
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  }
                ),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formatUserMemberships(_vm.usersMemberships).length === 0
            ? _c(
                "div",
                [
                  _c(
                    "b-list-group",
                    { attrs: { flush: "" } },
                    [
                      _c("b-list-group-item", [
                        _c("p", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                !_vm.hasOrganizations
                                  ? "This user does not have memberships with any organizations."
                                  : "This user does not have memberships with any organizations."
                              ) +
                              "\n          "
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("CreateUserMemberModal", {
        attrs: {
          userId: _vm.userId,
          pOrganization: _vm.user.primaryOrganization.id,
          showModal: _vm.showCreateUserMemberModal,
          memOrg: _vm.usersMembershipIds
        },
        on: {
          "update:showModal": function($event) {
            _vm.showCreateUserMemberModal = $event
          },
          "update:show-modal": function($event) {
            _vm.showCreateUserMemberModal = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.memberRecordId !== 0
        ? _c(
            "div",
            [
              _c("UpdateUserMemberModal", {
                attrs: {
                  userId: _vm.userId,
                  memberRecord: _vm.memberRecord,
                  showModal: _vm.showUpdateUserMemberModal,
                  disableDelete: _vm.isPrimaryOrg(
                    _vm.memberRecord.morganization.id
                  )
                },
                on: {
                  "update:showModal": function($event) {
                    _vm.showUpdateUserMemberModal = $event
                  },
                  "update:show-modal": function($event) {
                    _vm.showUpdateUserMemberModal = $event
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fdd3429c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdd3429c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/UserMemberships.vue
// module id = 1831
// module chunks = 0